document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-yarn-calc]').forEach(function (calcBox) {
    var formId = calcBox.dataset.productFormId;
    var form = formId ? document.getElementById(formId) : null;
    var skeinsProp = calcBox.querySelector('[data-yarn-prop="skeins"]');

    // Finn kjøpsknappene. Fungerer selv om knappene ligger utenfor selve
    // <form>-taget, siden Shopify-temaer ofte kobler dem sammen med form="...".
    function findSubmitButtons() {
      var buttons = [];
      if (form) buttons = buttons.concat(Array.from(form.querySelectorAll('[type="submit"]')));
      document.querySelectorAll('[type="submit"][form]').forEach(function (btn) {
        if (btn.getAttribute('form') === formId) buttons.push(btn);
      });
      return Array.from(new Set(buttons));
    }

    var submitButtons = findSubmitButtons();
    if (!submitButtons.length) return;

    submitButtons.forEach(function (btn) {
      btn.setAttribute('data-order-submit', '');
    });

    function updateState() {
      var ready = !!(skeinsProp && skeinsProp.value && skeinsProp.value.trim() !== '');

      submitButtons.forEach(function (btn) {
        btn.disabled = !ready;
        btn.classList.toggle('is-disabled', !ready);
      });

      calcBox.setAttribute('data-state', ready ? 'ready' : 'pending');

      var hint = calcBox.querySelector('.order-flow-hint');
      if (!ready && !hint) {
        hint = document.createElement('p');
        hint.className = 'order-flow-hint';
        hint.textContent = 'Fullfør mål og garnvalg for å låse opp bestilling.';
        calcBox.appendChild(hint);
      } else if (ready && hint) {
        hint.remove();
      }
    }

    // Beregningen skjer asynkront (fetch), så vi følger med jevnlig
    // i stedet for å stole på ett enkelt event.
    setInterval(updateState, 400);
    document.addEventListener('measurements:updated', updateState);

    updateState();
  });
});